import { render, staticRenderFns } from "./base-data.vue?vue&type=template&id=25a11d8a&"
import script from "./base-data.vue?vue&type=script&lang=js&"
export * from "./base-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports